/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";

window.OkMasthead = class OkMasthead {
	constructor(params) {
		Object.keys(params).forEach((key) => {
			this[key] = params[key];
		});

		this.el = $(`#${this.id}`);
		this.closer = $(`#${this.id}_closer`);
		this.body = $("body");

		this.listen();

		// add a class to the body if that's to be shown
		this.body.addClass("masthead-shown");

		if (this.countdownparams) {
			this.clock = this.el.find(".countdownclock");
			this.countdown = new OkCountdown({
				container: this.clock,
				now: this.countdownparams.now,
				deadline: this.countdownparams.deadline,
				showhours: true,
			});
			this.textclock = this.el.find(".textcountdown");
			if (this.textclock) {
				this.textcountdown = new TextCountdownTimer(
					this.textclock,
					this.countdownparams.deadline - this.countdownparams.now
				);
			}
		}

		if (this.throwaparty) {
			getCrunkedOut();
		}
	}

	listen() {
		return this.closer.on("click tap", ev => {
			ev.preventDefault();
			return this.close();
		});
	}

	close() {
		this.el.addClass("closed");
		this.body.removeClass("masthead-shown");

		if (this.close_sookie && this.close_sookie_hash) {
			// set a sookie so we can avoid showing this masthead to this user again
			AjaxSookie.set(this.close_sookie, 1, 86400 * 365, this.close_sookie_hash);
		}

		if (this.close_stat && this.close_stat_hash) {
			window.util.updateStats(
				this.close_stat,
				1,
				"counter",
				this.close_stat_hash
			);
		}

		if (this.countdown) {
			this.countdown.stop();
		}
		if (this.textcountdown) {
			this.textcountdown.stop();
		}

		if (this.throwaparty) {
			return everybodyGoHomePartysOver();
		}
	}

	open() {
		return this.el.removeClass("closed");
	}
};

class Takeover {
	constructor({ name, config, box }) {
		this.Data = {
			// imported
			name,

			config,
			box,

			// app state
			expanded: config.expanded,
		};

		this.Dom = {};
	}

	init() {
		// add stuff to the dom
		this.Dom.wrapper = $(`#${this.Data.name}_wrapper`);
		this.Dom.link = this.Dom.wrapper.find(".toptakeover-link");
		this.Dom.addl = this.Dom.wrapper.find(".toptakeover-addl");
		this.Dom.toggle = this.Dom.wrapper.find(".toptakeover-toggle");

		return this.listen();
	}

	listen() {
		// Throw a stat when this is clicked
		// (This assumes the link loads in _blank, which it should by default)
		this.Dom.link.on("click tap", ev => {
			let { clickstat, clickhash } = this.Data.config;
			return window.util.updateStats(clickstat, 1, "counter", clickhash);
		});

		// Expand / contract stuff
		return this.Dom.toggle.on("click tap", ev => {
			this.Data.expanded = !this.Data.expanded;
			return this.render();
		});
	}

	render() {
		return this.Dom.wrapper.toggleClass(
			"toptakeover--expanded",
			!!this.Data.expanded
		);
	}
}

window.MastheadTakeovers = {
	takeovers: {},

	add({ name, config, box }) {
		if (!name || !config || !box) {
			console.log("Invalid params: ", name, config, box);
			return;
		}

		this.takeovers[name] = new Takeover({ name, config, box });

		return this.takeovers[name].init();
	},
};



// WEBPACK FOOTER //
// ./src/legacy/masthead.js